/* eslint-disable indent */
/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Table, Spin, Switch, Button } from "antd";
import "./notSyncedDA.scss";
import API from "../../../api";
import urls from "../../../api/urls";
import useCustomNavigate from "../../../components/customNavigationHook";

const { DA_LIST } = urls;

const NotSyncedDA = () => {
  const navigate = useCustomNavigate();
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNum, setPageNum] = useState(0);
  const userinfo = JSON.parse(localStorage.getItem("userinfo"));
  const userId = JSON.parse(localStorage.getItem("userId"));

  useEffect(() => {
    getTableData();
  }, []);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") return <a>Previous</a>;
    if (type === "next") return <a>Next</a>;
    return (
      <div>
        <p>{originalElement}</p>
      </div>
    );
  };

  const getTableData = async (p1 = 10, p2 = 0) => {
    const cpId = userinfo?.spId ? userinfo?.spId : "";
    try {
      setLoading(true);
      const queryParams = new URLSearchParams({
        page: (p2 + 1).toString(),
        limit: p1.toString(),
        // syncStatus: "NOT_SYNCED",
        ...(cpId && { cpId: cpId.toString() }),
      });

      const result = await API.Api(
        `${DA_LIST}?${queryParams.toString()}`
      ).get();
      const response = result?.response?.data;
      if (response) {
        setTotal(response?.totalRecords);
        setTableData(response.data || []);
      }
    } catch (error) {
      console.error("Error fetching not synced DA list:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "deliveryAgentId",
      key: "deliveryAgentId",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (value, record) => `${record?.firstname} ${record?.lastname}`,
    },
    {
      title: "Mobile Number",
      dataIndex: "mobile",
      key: "mobile",
    },
    {
      title: "Vehicle Type",
      dataIndex: "vehicleType",
      key: "vehicleType",
    },
    {
      title: "Zone",
      dataIndex: "serviceableZone",
      key: "serviceableZone",
    },
    {
      title: "Hotspot",
      dataIndex: "assignedHotspot",
      key: "assignedHotspot",
    },
    {
      title: "Partner Type",
      dataIndex: "partnerType",
      key: "partnerType",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (_, record) => (
        <Switch
          checked={record.isActive}
          disabled={false}
          onChange={onStatusChange}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button type="primary" onClick={() => handleSync(record)}>
          SYNC TO ODA
        </Button>
      ),
    },
  ];

  const handlePageChange = (pagination) => {
    setPageSize(pagination.pageSize);
    setPageNum(pagination.current);
    getTableData(pagination.pageSize, pagination.current - 1);
  };

  const handleSync = (record) => {
    console.log("Syncing record:", record);
  };

  const onStatusChange = (value) => {
    console.log("Switch ", value);
  };

  return (
    <Spin spinning={loading}>
      <div className="not-synced-da-container m-1">
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={{
            pageSize: pageSize,
            itemRender: itemRender,
            total: total,
            current: pageNum === 0 ? 1 : pageNum,
          }}
          onChange={handlePageChange}
        />
      </div>
    </Spin>
  );
};

export default NotSyncedDA;
